import Head from 'next/head';

import SignUp from '../../../components/Auth/SignUp';
import { pageTitle } from '../../../components/shared/basic/customHead';

const SignUpPage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Sign-Up')}</title>
      </Head>
      <SignUp />
    </div>
  );
};
export default SignUpPage;
